import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=778a0eac&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a0eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('778a0eac')) {
      api.createRecord('778a0eac', component.options)
    } else {
      api.reload('778a0eac', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=778a0eac&scoped=true&", function () {
      api.rerender('778a0eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Eb5TuAN7RVhS/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports